package one.healthium.firebase.di

import org.koin.dsl.module

val firebaseModule = module {
    includes(firebasePlatformModule())
}